import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import media from '../../styles/media'

const ButtonContainer = styled(Link)`
  &.btn {
    padding: 1rem 2.1rem;
    border-radius: 0;
    line-height: normal;
    background-color: #3c4252;
    &.openLink {
      border-color: white;
    }
  }
  display: block;
  text-decoration: none;
  cursor: pointer;
  background-color: #3c4252;
  &:hover {
    background-color: #40b4e4;
  }
`

const TitleWrapper = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  text-align: center;
  color: #ffffff;
`

function NavButton(props) {
  const { to, title, className, isOpen } = props
  return (
    <ButtonContainer
      className={`btn ${className} ${isOpen && 'openLink'}`}
      to={to}
    >
      <TitleWrapper>{title.toUpperCase()}</TitleWrapper>
    </ButtonContainer>
  )
}

export default NavButton



// WEBPACK FOOTER //
// ./src/components/button/navButton.js